module.exports = __webpack_public_path__ + "static/img/Download_on_the_Play_Store.1451cea.png";